import React from "react";
import classNames from "classnames";

export interface IProps {
  stroke?: string;
  width?: string | number;
  height?: string | number;
  classes?: string;
}
const CloudIcon: React.FC<IProps> = ({ classes, stroke, width, height }) => {
  return (
    <svg
      width={width || "20px"}
      height={height || "20px"}
      className={classNames("icon-root", classes)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 11H8.72952C7.84545 11.0006 6.97892 10.7651 6.22839 10.3203C5.47787 9.87538 4.87344 9.23898 4.48379 8.48335C4.09414 7.72773 3.9349 6.88319 4.02415 6.0457C4.1134 5.20821 4.44757 4.41134 4.98869 3.74565C5.52981 3.07996 6.25618 2.57214 7.08526 2.2799C7.91434 1.98765 8.81289 1.92269 9.6788 2.09241C10.5447 2.26212 11.3433 2.6597 11.9837 3.23997C12.6242 3.82024 13.0809 4.55994 13.3019 5.375H14.0463C14.8296 5.375 15.5809 5.67132 16.1349 6.19876C16.6888 6.72621 17 7.44158 17 8.1875C17 8.93342 16.6888 9.64879 16.1349 10.1762C15.5809 10.7037 14.8296 11 14.0463 11H10ZM10 11V14.5M17.5 16.5H12M8 16.5H2.5"
        stroke={stroke || "#252D38"}
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="10"
        cy="16.5"
        r="2"
        stroke={stroke || "#252D38"}
        stroke-width="1.6"
      />
    </svg>
  );
};

export default CloudIcon;
